export default __webpack_public_path__ + "static/media/us-states.62f07b3b.svg";